"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const core = __importStar(require("../../core"));
const SubscriptionResponse_1 = require("./SubscriptionResponse");
const SubscriptionExtrasResponseModel_1 = require("./SubscriptionExtrasResponseModel");
exports.User = core.serialization.object({
    userId: core.serialization.property("user_id", core.serialization.string()),
    subscription: SubscriptionResponse_1.SubscriptionResponse,
    subscriptionExtras: core.serialization.property("subscription_extras", SubscriptionExtrasResponseModel_1.SubscriptionExtrasResponseModel.optional()),
    isNewUser: core.serialization.property("is_new_user", core.serialization.boolean()),
    xiApiKey: core.serialization.property("xi_api_key", core.serialization.string().optional()),
    canUseDelayedPaymentMethods: core.serialization.property("can_use_delayed_payment_methods", core.serialization.boolean()),
    isOnboardingCompleted: core.serialization.property("is_onboarding_completed", core.serialization.boolean()),
    isOnboardingChecklistCompleted: core.serialization.property("is_onboarding_checklist_completed", core.serialization.boolean()),
    firstName: core.serialization.property("first_name", core.serialization.string().optional()),
    isApiKeyHashed: core.serialization.property("is_api_key_hashed", core.serialization.boolean().optional()),
    xiApiKeyPreview: core.serialization.property("xi_api_key_preview", core.serialization.string().optional()),
    referralLinkCode: core.serialization.property("referral_link_code", core.serialization.string().optional()),
    partnerstackPartnerDefaultLink: core.serialization.property("partnerstack_partner_default_link", core.serialization.string().optional()),
});
